import Api from "./api.jsx";
import * as Constants from "../../../consts/Constants.js";

import auth from "../../auth/service";

const ADMIN_ROLE = 3501;

class NoticesService {

	constructor(baseUrl) {
		this.api = new Api(baseUrl);
	}

	canAdmin() {
		return auth.hasRole(ADMIN_ROLE);
	}

}

export default new NoticesService(Constants.FINAL_URL_NOTICES);